import Loadable from "../../components/Loadable";
import { lazy } from "react";
import {  HRREPORT } from "../../utils/constant";
// import ProductList from "./ProductList";
const StaffReport = Loadable(lazy(() => import("./staffReport")));
const DocumentReport = Loadable(lazy(() => import("./DocumentReport")));
const reportRoute = [
  {
    path: "/report/staffList",
    element: <StaffReport />,
    permission: HRREPORT,
    // auth:ROLE_PERMISSION
  },
  {
    path: "/report/documentReport",
    element: <DocumentReport />,
    permission: HRREPORT,
    // auth:ROLE_PERMISSION
  },
];

export default reportRoute;
